export type SarFieldInfoBadgeTone = 'danger' | 'success' | 'warning';

export interface SarFieldInfoBadge {
  text: string;
  tone: SarFieldInfoBadgeTone;
}

export interface SarFieldInfoSection {
  id: string;
  title: string;
  description: string;
  icon: string;
  badge?: SarFieldInfoBadge;
}

export interface SarFieldInfoDefinition {
  title: string;
  sections: SarFieldInfoSection[];
}

export type SarFieldInfoDictionary = Record<string, SarFieldInfoDefinition>;

export const sarFieldInfoDictionary: SarFieldInfoDictionary = {
  yukumlu: {
    title: '4.1. Yükümlü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlem bildirimini gönderen yükümlünün kodu.',
        icon: 'info',
      },
      {
        id: 'mandatoryType',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'info',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[4..10] rakamdan oluşan karakter dizisi',
        icon: 'info',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Bildirim yapan kuruluşa TCMB tarafından verilen kuruluş kodu kullanılacaktır. (Örnek: 0880)',
        icon: 'info',
      },
      {
        id: 'other',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.meslek': {
    title: '4.3.1.16. Meslek',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin mesleği',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Kişi mağdur değilse (“mağdur” alanı H ise) ve Tedbirler Yönetmeliği ‘KTT-02’ veya Uzaktan Kimlik Tespiti ‘KTT-03’ kimlik tespiti türü seçildiğinde doldurulması zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Açıklama\nM-01 | Antikacı\nM-02 | Asker\nM-03 | Avukat\nM-04 | Bahçıvan\nM-05 | Bakkal/Market/Kasap/Manav\nM-06 | Balıkçı\nM-07 | Bankacı\nM-08 | Bilimci\nM-09 | Boyacı\nM-10 | Çaycı\nM-11 | Çiçekçi\nM-12 | Çiftçi/Besici/Ormancı\nM-13 | Çilingir/Elektrikçi/Demirci/Tesisatçı/Marangoz\nM-14 | Aşçı/Garson/Barmen\nM-15 | Diş Hekimi\nM-16 | Doktor\nM-17 | Eczacı\nM-18 | Emekli\nM-19 | Esnaf/Zanaatkar\nM-20 | Ev Hanımı\nM-21 | Galerici\nM-22 | Gazeteci\nM-23 | Hizmetçi/Ebe\nM-24 | Hizmetli\nM-25 | İmalatçı\nM-26 | İnşaatçı\nM-27 | İşçi\nM-28 | Kaportacı\nM-29 | Komisyoncu\nM-30 | Konfeksiyoncu\nM-31 | Kurye\nM-32 | Kuyumcu/Sarraf\nM-33 | Memur\nM-34 | Milletvekili\nM-35 | Mimar/İç Mimar\nM-36 | Muhasebeci\nM-37 | Mühendis\nM-38 | Müşavir\nM-39 | Mütercim/Tercüman/Çevirmen\nM-40 | Nakliyeci\nM-41 | Öğrenci\nM-42 | Öğretmen/Eğitmen\nM-43 | Pilot/Kaptan\nM-44 | Polis/Jandarma/Güvenlik Görevlisi\nM-45 | Psikolog\nM-46 | Sanatçı\nM-47 | Sekreter/Yönetici Asistanı\nM-48 | Serbest Meslek\nM-49 | Şiparci\nM-50 | Sporcu/Antrenör/Hakem\nM-51 | Şoför\nM-52 | Tahsildar\nM-53 | Tamirci\nM-54 | Teknikyen\nM-55 | Temizlikçi\nM-56 | Terzi\nM-57 | Tüccar\nM-58 | Veteriner\nM-59 | Emekli\nM-60 | Biyolog\nM-61 | Borsacı/Finansçı/Ekonomist\nM-62 | Din Görevlisi\nM-63 | Diyetisyen\nM-64 | Fizyoterapist\nM-65 | Hakim/Savcı\nM-66 | Hostes\nM-67 | Kamu Görevlisi\nM-68 | Noter\nM-69 | Öğretim Görevlisi/Akademisyen\nM-70 | Programcı/Yazılımcı/Analist\nM-71 | Tasarımcı (Grafik, Moda, Sanat, Reklam vs.)\nM-72 | Berber/Kuaför/Güzellik Uzmanı\nM-73 | Dealer/Broker\nM-74 | Danışman\nM-75 | Diplomat/Harcıyevi\nM-76 | Distribütör\nM-77 | Fotoğrafçı\nM-78 | İşletmeci (Kafe/Otel/Restoran/Eğlence)\nM-79 | Manken/Fotomodel\nM-80 | Müteahhit\nM-81 | Muhtar\nM-82 | Rehber/Tur Operatörü\nM-83 | Pazarlamacı\nM-84 | Satış Görevlisi/Tezgahçı\nM-85 | Reklamcı\nM-86 | Gemi Kaptanı\nM-87 | Sağlık Personeli\nM-88 | Vali\nM-89 | Kaymakam\nM-90 | Bürokrat\nM-91 | Üst Düzey Yönetici (Genel Müdür, Genel Müdür Yard., CEO vb.)\nM-92 | Yerel Yönetici (Belediye Başkanı vb.)\nM-93 | Peşin\nM-94 | Firma Ortağı/Sahibi\nM-99 | Diğer',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.ekBilgi': {
    title: '4.3.1.17. Ek Bilgi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişiye ait ek bilgiler',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adresler': {
    title: '4.3.1.18. Adresler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu alanda gerçek kişinin adres bilgileri verilecektir. Gerçek kişinin birden fazla adresi mevcut ise her bir adres ayrı ayrı belirtilecektir.',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.adres': {
    title: '4.3.1.18.1. Adres',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Adres tipi bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..6] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          "Belirtilen adres tipi;\n• Ev adresi ise adres tipi 'ev'\n• İş adresi ise adres tipi 'is'\n• Diğer bir adres ise adres tipi 'diger' olarak belirtilmelidir.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Açıklama\ndiger | Diğer Adres\nev | Ev Adresi\nis | İş Adresi\nmerkez | Merkez Adresi\nsube | Şube Adresi',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adres.adresSatir': {
    title: '4.3.1.18.1.1. Adres Satırı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Adres bilgisi satırı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..200] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adres.postaKodu': {
    title: '4.3.1.18.1.2. Posta Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Posta kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..10] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adres.ilKodu': {
    title: '4.3.1.18.1.3. İl Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İl kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..2] rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '• İl kodu alanında illerin plaka kodu belirtilecektir.\n• İl kodu belirtilmişse ülke ‘TR’ olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Yabancı adresler için il bilgisi adres satırları içerisinde belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adres.ilceKodu': {
    title: '4.3.1.18.1.4. İlçe Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İlçe kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '4 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İlçe kodları belirtilirken Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanan MERNİS ilçe kodları kullanılacaktır.\n• Belirtilen ilçe kodu il kodu alanında belirtilen ile bağlı bir olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'İlçe kodu olarak bilinmiyorsa veya yabancı bir adres belirtiliyorsa ilçe bilgisi adres satırları içerisinde belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adres.ulkeKodu': {
    title: '4.3.1.18.1.5. Ülke Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Ülke kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '2 harften oluşan ülke kodu',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'İlçe kodu olarak bilinmiyorsa veya yabancı bir adres belirtiliyorsa ilçe bilgisi adres satırları içerisinde belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.iletisimBilgileri': {
    title: '4.3.1.19. İletişim Bilgileri',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu alanda gerçek kişilerin (biliniyorsa) iletişim bilgileri (telefon, e-posta) belirtilecektir. Her bir farklı iletişim bilgisi için bu alan tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.iletisimBilgileri.iletisimBilgisi': {
    title: '4.3.1.19.1. İletişim Bilgisi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Gerçek kişinin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[7..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Telefon numarasını "+"+ülke kodu+il kodu+telefon numarası+dahili numara şeklinde belirtiniz. Örnek: +903125550000-1221.\n• E-posta adresi içerisinde "@" işaretinin bulunması zorunludur.\n• Tedbirler Yönetmeliği "KTT-02" veya Uzaktan Kimlik Tespiti "KTT-03" kimlik tespiti türü seçildiğinde e-posta ve cep telefonu bilgisinin doldurulması zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          '• İletişim bilgisi tipi belirtilen bilginin türüne göre;\n  • İş Telefonu numarası ise iletişim tipi="is"\n  • Ev Telefonu numarası ise iletişim tipi="ev"\n  • Cep Telefonu numarası ise iletişim tipi="cep"\n  • Diğer Telefon numarası ise iletişim tipi="diger"\n  • Faks numarası ise iletişim tipi="faks"\n  • E-posta adresi ise iletişim tipi="eposta" olarak belirtilmelidir.\n\nKod | Açıklama\nis | İş telefonu\nfaks | Fax\nev | Ev telefonu\neposta | Eposta\ndiger | Diğer\ncep | Cep telefonu',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.iletisimBilgileri.tip': {
    title: '4.3.1.19.1. İletişim Bilgisi Tipi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Gerçek kişinin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'İletişim bilgisi tipi belirtilen bilginin türüne göre;\n• İş Telefonu numarası ise iletişim tipi="is"\n• Ev Telefonu numarası ise iletişim tipi="ev"\n• Cep Telefonu numarası ise iletişim tipi="cep"\n• Diğer Telefon numarası ise iletişim tipi="diger"\n• Faks numarası ise iletişim tipi="faks"\n• E-posta adresi ise iletişim tipi="eposta"',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.kimlikBilgileriSahte': {
    title: '4.3.1.20. Kimlik Bilgileri Sahte',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Gerçek kişinin ibraz etmiş olduğu kimlik belgesinin veya beyan ettiği bilgilerin sahte olup olmadığını belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’ veya ‘H’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Gerçek kişiye ait belirtilen bilgilerin;\n• Sahte bir kimliğe ve/veya sahte beyana dayandığını belirtmek için ‘E’\n• Bilgilerin sahte olmadığını belirtmek için ‘H’ değerini kullanınız.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.magdur': {
    title: '4.3.1.21. Mağdur',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemi gerçekleştiren kişinin bilinmemesi ve yalnızca müşteri olan mağdura ilişkin bilgiler varsa belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’ veya ‘H’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Gerçek kişiye ait belirtilen bilgilerin; kişi mağdur ise ‘E’, kişi mağdur değilse ‘H’ değerini belirtiniz.\n• Kimlik tespit türü Müşteri Değil/Anonim Hesap (KTT-04) ise mağdurların ‘H’ olarak doldurulacaktır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kişi mağdur (“mağdur” alanı ‘E’) ise ve Basitleştirilmiş Tedbirler ‘KTT-01’, Tedbirler Yönetmeliği ‘KTT-02’ veya Uzaktan Kimlik Tespiti ‘KTT-03’ kimlik tespit türü seçildiğinde kişinin tckn, ykn veya kimlik belgeleri bölümünde “belgeTuru” parametresinde pasaport bilgisinden az birinin doldurulması zorunludur.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.kimlikTespitTuruTip': {
    title: '4.3.1.22. Kimlik Tespit Türü Tip',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemi gerçekleştirdiği değerlendirilen müşterinin kimlik tespitinin yapıldığı mevzuat belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..6] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Kimlik Tespit Türü alanında\n• Basitleştirilmiş Tedbirler ise ‘KTT-01’\n• Tedbirler Yönetmeliği ise ‘KTT-02’\n• Uzaktan Kimlik Tespiti ise ‘KTT-03’\n• Müşteri Değil/Anonim Hesap ise ‘KTT-04’ seçeneklerinden biri işaretlenecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Açıklama\nKTT-01 | Basitleştirilmiş Tedbirler\nKTT-02 | Tedbirler Yönetmeliği\nKTT-03 | Uzaktan Kimlik Tespiti\nKTT-04 | Müşteri Değil/Anonim Hesap',
        icon: 'link',
      },
    ],
  },
  digerKisiler: {
    title: '4.4. Diğer Kişiler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlıkta sadece adına işlem yapılan kuruluşlar değil, şüpheli işlemdeki eylem ile dolaylı olarak ilgili olduğu değerlendirilen tüm kuruluşların bilgisine yer verilmelidir.',
        icon: 'info',
      },
    ],
  },
  digerKisi: {
    title: '4.4.1. Diğer Kişi',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık şüpheli işlem bildirimindeki eylem ile doğrudan veya dolaylı olarak ilgisi olduğu değerlendirilen tüm kuruluşların bilgisini belirtmek amacı ile kullanılır. Birden fazla tüzel kişiye dair bilginin belirtilmesi için her bir tüzel kişi adedince bu başlık tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'digerKisi.islemleBaglantisi': {
    title: '4.4.1.1. İşlemle Bağlantısı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bilgisi verilen kişinin şüpheli işlem ile olan bağlantısı bu alanda belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Tüzel kişi temsil veya vekâlet ilişkisi kapsamında adına işlem yapılan kişi ise ‘DB-01’\n• Şüpheli durumla dolaylı olarak alakalı olduğu düşünülen kuruluşlar için ‘DB-02’\n• Kişi mağdur değilse (“mağdur” alanı ‘H’ ise) bu alan zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Açıklama\nDB-01 | Adına İşlem Yapılan\nDB-02 | Dolaylı Olarak İlgili',
        icon: 'link',
      },
    ],
  },
  'digerKisi.islemleBaglantisiAciklama': {
    title: '4.4.1.2. İşlemle Bağlantısı Açıklama',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bilgisi verilen kişinin şüpheli işlem ile olan bağlantısının açıklaması',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..100] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '‘islemleBaglantisi’ alanı dolaylı olarak ilgili ‘DB-02’ değerini taşıyorsa belirtilmelidir. Aksi durumda boş bırakılmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.kurulusNevi': {
    title: '4.4.1.3. Kuruluş Nevi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin nevi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan,[1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Belirtilen kuruluş;\n• Ticaret Siciline Kayıtlı Tüzel Kişiler ise ‘KN-01’\n• Yurt dışında Yerleşik Tüzel Kişiler ise ‘KN-02’\n• Tüzel Kişiliği Olmayan Teşekküller ise ‘KN-03’\n• Yurt Dışında Kurulmuş Güven Sözleşmeleri ise ‘KN-04’\n• Dernek ise ‘KN-05’\n• Vakıf ise ‘KN-06’\n• Siyasi Parti ise ‘KN-07’\n• Sendika, Federasyon, Konfederasyon ise ‘KN-08’ değerini taşımalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Açıklama\nKN-01 | Ticaret Siciline Kayıtlı Tüzel Kişiler\nKN-02 | Yurt Dışında Yerleşik Tüzel Kişiler\nKN-03 | Tüzel Kişiliği Olmayan Teşekküller\nKN-04 | Yurt Dışında Kurulmuş Güven Sözleşmeleri\nKN-05 | Dernek\nKN-06 | Vakıf\nKN-07 | Siyasi Parti\nKN-08 | Sendika/Federasyon/Konfederasyon',
        icon: 'link',
      },
    ],
  },
  'digerKisi.unvan': {
    title: '4.4.1.4. Unvan',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Ticaret siciline kayıtlı tüzel kişiler için firmanın ticaret unvanı; dernek, vakıf, sendika, konfederasyon, tüzel kişiliği olmayan teşekküller için bunların adı belirtilecektir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..200] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Bu alanda tüm ticari firma unvanı firma nev’ini de içerecek şekilde açık olarak belirtilmelidir (Öztürkler Gıda İthalat İhracat Sanayi Ltd. Şti. gibi).',
        icon: 'link',
      },
    ],
  },
  'digerKisi.isletmeAdi': {
    title: '4.4.1.5. İşletme Adı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin işletme adı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..200] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Firmanın ticari unvanı haricinde piyasada yaygın olarak bilinen bir işletme adı, marka adı vs. varsa bu alanda belirtilecektir (AAA Ltd. Şti.’ne ait Taksim’deki restoranın adının “XXX” olması gibi).',
        icon: 'link',
      },
    ],
  },
  'digerKisi.vkn': {
    title: '4.4.1.6. VKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Türkiye’de vergi mükellefi olan kuruluşların vergi kimlik numarası belirtilecektir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '10 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Bu alanda belirtilen vergi kimlik numarası Gelir İdaresi Başkanlığı tarafından yayınlanan VKN üretme algoritmasına uygun olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.sicilNo': {
    title: '4.4.1.7. Sicil No',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin sicil numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Bu alanda;\n• Ticaret siciline kayıtlı tüzel kişiler için bilinliyorsa MERSİS numarası\n  - MERSİS numarası bilinmiyorsa ticaret sicil numarası,\n• Dernekler için kütük numarası,\n• Vakıflar için merkezi sicil kayıt numarası,\n• Sendika ve konfederasyonlar için sicil numarası belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'digerKisi.faaliyetKonusu': {
    title: '4.4.1.8. Faaliyet Konusu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin ana faaliyet konusu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..100] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.ulkeKodu': {
    title: '4.4.1.9. Ülke Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin faaliyet gösterdiği ülke kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '2 harften oluşan ülke kodu',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.\nKişilik mağdur değilse (“mağdur” alanı ‘H’ ise) bu alan zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.ilKodu': {
    title: '4.4.1.10. İl Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin faaliyet gösterdiği il kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..2] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'İl kodu alanında; illerin plaka kodu belirtilecektir.\nİl kodu belirtilen ülke ‘TR’ olduğu zaman geçerli olacaktır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.ilceKodu': {
    title: '4.4.1.11. İlçe Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin faaliyet gösterdiği ilçenin kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '4 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İlçe kodları belirtilirken Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanan MERNİS ilçe kodları kullanılacaktır.\n• Belirtilen ilçe kodu il kodu alanında belirtilen ile bağlı bir olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.kurulusTarihi': {
    title: '4.4.1.12. Kuruluş Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğin kuruluş tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• 01/01/1800 tarihinden önceki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.websitesi': {
    title: '4.4.1.13. Websitesi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğe ait web sitesi adresi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.ekBilgi': {
    title: '4.4.1.14. Ek Bilgi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kişiliğe dair sahip olunan diğer bilgiler',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adresler': {
    title: '4.4.1.15. Adresler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu alanda tüzel kişinin adres bilgileri verilecektir. Tüzel kişinin birden fazla adresi mevcut ise her bir adres ayrı ayrı belirtilecektir.',
        icon: 'info',
      },
    ],
  },
  'digerKisi.adres': {
    title: '4.4.1.15.1. Adres',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Adres tip bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..6] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          "Belirtilen adres tipi;\n• Merkez adresi ise adres tip='merkez'\n• Şube adresi ise adres tip='sube'\n• Diğer bir adres ise adres tip='diger' olarak belirtilmelidir.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Açıklama\ndiger | Diğer Adres\nev | Ev Adresi\nis | İş Adresi\nmerkez | Merkez Adresi\nsube | Şube Adresi',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adres.adresSatir': {
    title: '4.4.1.15.2. Adres Satırı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Adres bilgisi satırı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..200] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adres.postaKodu': {
    title: '4.4.1.15.3. Posta Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Posta kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..10] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adres.ilKodu': {
    title: '4.4.1.15.4. İl Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İl kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..2] rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'İl kodu alanında illerin plaka kodu belirtilecektir.\nYabancı adresler için il bilgisi adres satırları içerisinde belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adres.ilceKodu': {
    title: '4.4.1.15.5. İlçe Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İlçe kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '4 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İlçe kodları belirtilirken Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanan MERNİS ilçe kodları kullanılacaktır.\n• Belirtilen ilçe kodu il kodu alanında belirtilen ile bağlı bir olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'İlçe kodu olarak bilinmiyorsa veya yabancı bir adres belirtiliyorsa ilçe bilgisi adres satırları içerisinde belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'digerKisi.adres.ulkeKodu': {
    title: '4.4.1.15.6. Ülke Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Ülke kodu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '2 harften oluşan ülke kodu',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.iletisimBilgileri': {
    title: '4.4.1.16. İletişim Bilgileri',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu alanda tüzel kişilerin (biliniyorsa) iletişim bilgileri (telefon, e-posta) belirtilecektir. Her bir farklı iletişim bilgisi için bu alan tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'digerKisi.iletisimBilgisi': {
    title: '4.4.1.16.1. İletişim Bilgisi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Tüzel kişinin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[7..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Telefon numarasını "+"+ülke kodu+il kodu+telefon numarası+dahili numara şeklinde belirtiniz. Örnek: +903125550000-1221.\n• E-posta adresi içerisinde "@" işaretinin bulunması zorunludur.\n• E-posta ve cep telefonu girilmesi zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          '• İletişim bilgisi tipi belirtilen bilginin türüne göre;\n  • İş Telefonu numarası ise iletişim tip="is"\n  • Ev Telefonu numarası ise iletişim tip="ev"\n  • Cep Telefonu numarası ise iletişim tip="cep"\n  • Diğer Telefon numarası ise iletişim tip="diger"\n  • Faks numarası ise iletişim tip="faks"\n  • E-posta adresi ise iletişim tip="eposta" olarak belirtilmelidir.\n\nKod | Kod Açıklama\nis | İş Telefonu\nfaks | Fax\nev | Ev telefonu\neposta | Eposta\ndiger | Diğer\ncep | Cep telefonu',
        icon: 'link',
      },
    ],
  },
  'digerKisi.iletisimBilgileri.tip': {
    title: '4.4.1.16.1. İletişim Bilgisi Tipi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Tüzel kişinin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'İletişim bilgisi tipi belirtilen bilginin türüne göre;\n• İş Telefonu numarası ise iletişim tipi="is"\n• Ev Telefonu numarası ise iletişim tipi="ev"\n• Cep Telefonu numarası ise iletişim tipi="cep"\n• Diğer Telefon numarası ise iletişim tipi="diger"\n• Faks numarası ise iletişim tipi="faks"\n• E-posta adresi ise iletişim tipi="eposta"',
        icon: 'link',
      },
    ],
  },
  'digerKisi.kimlikBilgileriSahte': {
    title: '4.4.1.17. Kimlik Bilgileri Sahte',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Tüzel kişinin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’ veya ‘H’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Tüzel/diğer kişiye ait belirtilen bilgilerin;\n• Sahte bir belgeye ve/veya sahte beyana dayandığını belirtmek için ‘E’\n• Bilgilerin sahte olmadığını belirtmek için ‘H’ değerini kullanınız.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'digerKisi.magdur': {
    title: '4.4.1.18. Mağdur',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemi gerçekleştiren kişinin bilinmemesi ve yalnızca müşteri olan mağdura ilişkin bilgiler varsa belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’ veya ‘H’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Tüzel kişiye ait belirtilen bilgilerden;\n• Kişi mağdur ise ‘E’\n• Kişi mağdur değilse ‘H’ değerini kullanınız.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  supheliIslemler: {
    title: '4.5. Şüpheli İşlemler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında şüpheli işlem bildirimine gerekçe teşkil eden şüpheli işlem veya işlemler belirtilecektir. Bir şüpheli işlem bildiriminde en az bir adet şüpheli işlem bilgisine yer verilecektir.',
        icon: 'info',
      },
    ],
  },
  supheliIslem: {
    title: '4.5.1. Şüpheli İşlem',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Şüpheli işlem bildirimine gerekçe teşkil eden her bir işlem ayrı ayrı bu başlık ile belirtilecektir. Şüpheli işlem bildirimine gerekçe olan her bir eylem tarih ile tek tek bildirilebileceği gibi, belli bir tarih aralığındaki işlemleri bir kerede bildirimeyi ihtiva eden çoklu işlem şeklinde de yapılabilir.\n\nTekil eylemlerin bildiriminde sadece “islemTarihi” alanının belirtilmesi yeterlidir. Bağlantılı eylemlerde ise bağlantılı işlemlerin başladığı tarih “islemTarihi” alanında, bittiği tarih ise “islemTarihi2” alanında belirtilecektir. Şüpheli işlem bildirimine kaynaklık eden her bir tekil ve çoklu işlem ayrı ayrı bildirilmeldir.',
        icon: 'info',
      },
    ],
  },
  'supheliIslem.islemCesidi': {
    title: '4.5.1.1. İşlem Çeşidi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Bildirim konusu işlem tek bir işlem ise tek işlem, birden fazla işlem ya da belirli bir tarih aralığındaki işlemleri içeriyor ise çoklu işlem olduğu belirtilecektir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: "İşlem çeşidi seçeneklerinden yalnızca biri seçilecektir.\n• Tek işlem ise 'C-01'\n• Çoklu işlem ise 'C-02' kodları belirtilir.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Kod Açıklama\nC-01 | Tek İşlem\nC-02 | Çoklu İşlem',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemTarihi': {
    title: '4.5.1.2. İşlem Tarihi 1',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• 01/01/1970 tarihinden önceki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alan tekil işlemler için ilgili işlemin tarihi, bağlantılı veya çoklu işlemler için işlemlerin başlangıç tarihini ifade eder.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemTarihi2': {
    title: '4.5.1.3. İşlem Tarihi 2',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Çoklu işlemlerin bitiş tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• “islemTarihi” den önceki bir tarih olmamalıdır.\n• İşlem çeşidi Çoklu işlem ‘C-02’ ise bitiş tarihi belirtilir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alan bağlantılı veya çoklu işlemlerde işlemlerin bitiş tarihini ifade eder.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.durum': {
    title: '4.5.1.4. İşlem Durumu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin ne aşamada olduğu bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan,[1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Belirtilen şüpheli işlem;\n• Gerçekleştirilmiş bir işlem ise ‘D-01’\n• Teşebbüs aşamasında kalmış bir işlem ise ‘D-02’ olarak belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Kod Açıklama\nD-01 | Gerçekleştirilmiş\nD-02 | Teşebbüs Aşamasında',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.hesabaBagli': {
    title: '4.5.1.5. Hesaba Bağlı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin belli bir hesaba/hesaplara bağlı olup olmadığını belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’ veya ‘H’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Şüpheli işlemin;\n• Hesaba bağlı olduğunu belirtmek için ‘E’\n• Hesaba bağlı olmadığını belirtmek için ‘H’ değeri girilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Şüpheli işlem belli hesaba/hesaplara bağlı olarak gerçekleştirilmişse işleme konu olan hesap bilgileri “hesaplar” başlığında belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.tutarTP': {
    title: '4.5.1.6. Tutar TP',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin Türk Lirası cinsinden parasal tutarı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '################.######## formatında numerik bilgi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Gerçekleştirilmiş bir işlem (işlem durumu ‘D-01’) ise bu alanın doldurulması zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Yabancı para ile yapılan işlemlerde işlem tutarının Türk Lirası karşılığı bu alanda belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.tutar': {
    title: '4.5.1.7. Tutar',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin parasal tutarı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '################.######## formatında numerik bilgi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Gerçekleştirilmiş bir işlem (işlem durumu ‘D-01’) ise bu alanın doldurulması zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Şüpheli işleme ait tutar ilgili para birimi cinsinden bu alanda belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.paraBirimi': {
    title: '4.5.1.8. Para Birimi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin para birimi kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '3 harften oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Para birimi ISO 4217 standardında yer alan para birimi kodlarından bir değeri içermelidir.\n• Gerçekleştirilmiş bir işlem (işlem durumu ‘D-01’) ise bu alanın doldurulması zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          '• Hisse senedi, lot vs. gibi işlemler için para birimi alanı ‘XXX’ olarak belirtilecektir.\n\nKod | Kod Açıklama\nADP | Andora Peseta\nAED | Birleşik Arap Emirlikleri Drahmi\nAFA | Afgani (AFN ile Değiştirildi) Eski\nAFN | Afganistan Afganı\nALF | Altın Gram (0.999)\nALK | Lek Eski Arnavutluk\nALL | Arnavutluk Lek\nAMD | Ermeni Dram\nANG | Hollanda Antilleri Guikder\nAOA | Angola Kwanza\nAON | Angola Yeni Kwanza (AOA ile Değiştirildi)\nARP | Arjantin Peso (ARS ile Değiştirildi)\nARS | Arjantin Pezosu\nATS | Avusturya Şilin\nAUD | Avustralya Doları\nAWG | Aruba Florini\nAZM | Azerbaycan Manat (AZN ile Değiştirildi)\nAZN | Azerbaycan Manatı\nBAM | Bosna-Hersek Markı\nBBD | Barbados Doları\nBDT | Bangladeş Taka\nBEC | Belçika Frankı (Convertible)\nBEF | Belçika Frankı\nBEL | Belçika Frankı (Financial)\nBGJ | Bulgar Lev A/52 (BGN ile Değiştirildi)\nBGK | Bulgar Lev A/62 (BGN ile Değiştirildi)\nBGL | Bulgar Lev A/99 (BGN ile Değiştirildi)\nBGN | Bulgar Levası\nBHD | Bahreyn Dinarı\nBIF | Burundi Frankı\nBMD | Bermuda Doları\nBND | Brunei Doları\nBOB | Boliviano\nBOP | Bolivya Pesosu (BOB ile Değiştirildi)\nBOV | Bolivya Mvdol\nBRB | Brezilya Cruzeiro (BRL ile Değiştirildi)\nBRC | Brezilya Cruzado (BRL ile Değiştirildi)\nBRL | Brezilya Reali\nBSD | Bahama Doları\nBWP | Botsvana Pulası\nBYN | Belarus Rublesi\nBZD | Belize Doları\nCAD | Kanada Doları\nCDF | Kongo Frankı\nCDZ | Zaire Frankı (CDF ile Değiştirildi)\nCHF | İsviçre Frangı\nCLP | Şili Pezosu\nCNH | Çin Offshore Yuanı\nCNX | Çin Halk Bankası Doları (CNY ile Değiştirildi)\nCNY | Çin Yuanı\nCOP | Kolombiya Pezosu\nCRC | Kosta Rika Kolonu\nCSD | Eski Sırbistan Dinarı\nCSJ | Çekoslovak Korunası A/53\nCSK | Çekoslovak Korunası (CZK ve SKK ile Değiştirildi)\nCUP | Küba Pezosu\nCVE | Cape Verde Esküdosu\nCYP | Kıbrıs Poundu\nCYR | Çeyrek Altın\nCZK | Çek Korunası\nDDM | Doğu Almanya Markı (DEM ile Değiştirildi)\nDEM | Alman Markı\nDJF | Cibuti Frankı\nDKK | Danimarka Kronu\nDOP | Dominik Pezosu\nDZD | Cezayir Dinarı\nECS | Ekvator Sucre (USD ile Değiştirildi)\nEEK | Estonya Kronu\nEGP | Mısır Poundu\nERN | Eritre Nafka\nESA | İspanyol Pezeta (Hesap A)\nESB | İspanyol Pezeta (Hesap B)\nESP | İspanyol Pezeta\nETB | Etiyopya Birri\nEUR | Euro\nFIM | Finlandiya Markası\nFJD | Fiji Doları\nFKP | Falkland Adaları Poundu\nFRF | Fransız Frankı\nGBP | İngiliz Sterlini\nGEL | Gürcü Larisi\nGHC | Gana Cedi\nGIP | Cebelitarık Poundu\nGMD | Gambiya Dalasisi\nGNF | Gine Frankı\nGRD | Yunan Drahmisi\nGTQ | Guatemala Quetzalı\nGWP | Gine-Bissau Pezosu\nGYD | Guyana Doları\nHKD | Hong Kong Doları\nHNL | Honduras Lempirası\nHRK | Hırvat Kunası\nHUF | Macar Forinti\nIDR | Endonezya Rupiahı\nIEP | İrlanda Poundu\nILP | İsrail Poundu (ILR ile Değiştirildi)\nILR | İsrail Eski Şekeli (ILS ile Değiştirildi)\nILS | İsrail Şekeli\nINR | Hindistan Rupisi\nIQD | Irak Dinarı\nIRR | İran Riyali\nISJ | İzlanda Eski Kronu (ISK ile Değiştirildi)\nISK | İzlanda Kronu\nITL | İtalyan Lireti\nJMD | Jamaika Doları\nJOD | Ürdün Dinarı\nJPY | Japon Yeni\nKES | Kenya Şilini\nKGS | Kırgız Somu\nKHR | Kamboçya Rieli\nKMF | Komor Frankı\nKPW | Kuzey Kore Wonu\nKRW | Güney Kore Wonu\nKWD | Kuveyt Dinarı\nKYD | Cayman Adaları Doları\nKZT | Kazakistan Tengesi\nLAK | Laos Kip\nLBP | Lübnan Poundu\nLKR | Sri Lanka Rupisi\nLRD | Liberya Doları\nLTL | Litvanya Litası\nLUF | Lüksemburg Frankı\nLYD | Libya Dinarı\nMAD | Fas Dirhemi\nMDL | Moldova Leusu\nMGA | Madagaskar Ariarisi\nMKD | Makedonya Dinarı\nMKN | Makedonya Dinarı A/93 (MKD ile Değiştirildi)\nMNT | Moğolistan Tugriki\nMRO | Moritanya Ouguiyası\nMTL | Malta Lirası\nMUR | Mauritius Rupisi\nMVQ | Maldiv Rupisi (MVR ile Değiştirildi)\nMVR | Maldiv Rufiyası\nMWK | Malavi Kvaçası\nMXN | Meksika Pezosu\nMXP | Meksika Pesosu (MXN ile Değiştirildi)\nMYR | Malezya Ringgiti\nMZN | Mozambik Metikali\nNGN | Nijerya Nairası\nNIO | Nikaragua Córdoba’sı\nNLG | Hollanda Florini\nNOK | Norveç Kronu\nNPR | Nepal Rupisi\nNZD | Yeni Zelanda Doları\nOMR | Umman Riyali\nPEH | Peru Solu (PEN ile Değiştirildi)\nPEN | Peru Solu\nPGK | Papua Yeni Gine Kina\nPHP | Filipin Pezosu\nPKR | Pakistan Rupisi\nPLN | Polonya Zlotisi\nPLZ | Polonya Zlotisi A/94 (PLN ile Değiştirildi)\nPTE | Portekiz Esküdosu\nPYG | Paraguay Guaranisi\nQAR | Katar Riyali\nROK | Romanya Leusu A/52 (ROL ile Değiştirildi)\nROL | Romanya Leusu A/05 (RON ile Değiştirildi)\nRON | Rumen Yeni Leusu\nRSD | Sırbistan Dinarı\nRUB | Rusya Rublesi\nRUR | Rusya Rublesi (RUB ile Değiştirildi)\nRWF | Ruanda Frankı\nSAR | Suudi Arabistan Riyali\nSBD | Solomon Adaları Doları\nSCR | Seyşeller Rupisi\nSDD | Sudan Dinarı\nSEK | İsveç Kronu\nSGD | Singapur Doları\nSHP | Saint Helena Poundu\nSIT | Slovenya Toları\nSKK | Slovak Korunası\nSLE | Sierra Leone Leonesi\nSOS | Somali Şilini\nSRD | Surinam Doları\nSRG | Surinam Guildeni (SRD ile Değiştirildi)\nSUR | Sovyetler Birliği Rublesi (RUB ile Değiştirildi)\nSVC | El Salvador Kolonu\nSYP | Suriye Poundu\nSZL | Esvatini Lilangeni\nTHB | Tayland Bahtı\nTJS | Tacikistan Somonisi\nTMM | Türkmenistan Manatı (Eski)\nTMT | Türkmenistan Manatı (Yeni)\nTND | Tunus Dinarı\nTOP | Tonga Pa’anga\nTPE | Timor Esküdosu\nTRL | Türk Lirası (Eski)\nTRY | Türk Lirası\nTTD | Trinidad Tobago Doları\nTWD | Tayvan Doları\nTZS | Tanzanya Şilini\nUAH | Ukrayna Grivnası\nUGW | Uganda Eski Şilini (UGX ile Değiştirildi)\nUGX | Uganda Şilini\nUSD | ABD Doları\nUYN | Uruguay Eski Pesosu (UYU ile Değiştirildi)\nUYU | Uruguay Pezosu\nUZS | Özbekistan Somu\nVED | Venezuela Bolivarı\nVNC | Vietnam Eski Dongu (VND ile Değiştirildi)\nVND | Vietnam Dongu\nVUV | Vanuatu Vatusu\nWST | Samoa Tala\nXAF | CFA Frankı (BEAC)\nXAG | Gümüş\nXAU | Altın\nXBA | Bond Markets Units European\nXBB | European Monetary Unit\nXBC | E.U.A.-9\nXBD | E.U.A.-17\nXCD | Doğu Karayip Doları\nXDR | Özel Çekme Hakları\nXEU | Avrupa Para Değişim Birimi (ECU)\nXFO | Gold-Franc\nXFU | UIC-Franc\nXOF | CFA Frankı (BCEAO)\nXPD | Paladyum\nXPF | Fransız Polinezyası Frankı\nXPT | Platin\nYDD | Güney Yemen Dinarı (YER ile Değiştirildi)\nYER | Yemen Riyali\nYUD | Yugoslavya Dinarı (CSD ile Değiştirildi)\nYUM | Yugoslavya Dinarı\nZAR | Güney Afrika Randı\nZMW | Zambiya Kvaçası\nZWL | Zimbabve Doları\nAAA | AAAAAA',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemTuru': {
    title: '4.5.1.9. İşlem Türü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin türü/türleri',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Gerçekleştirilmiş bir işlemde (işlem durumu ‘D-01’ ise) bu alan zorunludur.\n• Tek seferde gerçekleştirilmiş işlemler için bildirimi yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan işlem türlerinden biri belirtilecektir.\n• Belli tarihler arasında gerçekleşmiş çoklu işlemler belirtilirken bildirimi yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan işlem türlerinden bir veya daha fazlası virgül ile ayrılarak belirtilecektir (Örnek: ‘IG-1201,IG-1202,IG-1310’).',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Kod Açıklama\nIG-1201 | Para yatırma\nIG-1202 | Para çekme\nIG-1310 | Türk Lirası Transfer (Yurt içi)\nIG-1311 | Döviz Transfer (Yurt içi)\nG-1410 | Türk Lirası Transfer (Yurt dışı) Gram(0.999)\nIG-1411 | Döviz Transfer (Yurt dışı)\nIG-1501 | Nakdi kredi\nIG-1502 | Gayrinakdi kredi\nIG-1503 | Diğer Kredi\nIG-1601 | Döviz/efektif alım satım\nIG-1602 | Arbitraj işlemleri\nIG-1701 | Fatura\nIG-1702 | Vergi\nIG-1703 | Maaş\nIG-1704 | Kira\nIG-1705 | Aidat\nIG-1706 | Sigorta\nIG-1707 | Bahis\nIG-1708 | Bağış\nIG-1709 | Burs\nIG-1710 | Bireysel Emeklilik Ödemeleri\nIG-1711 | Diğer Ödemeler\nIG-1801 | Komisyon\nIG-1802 | Faiz/kar payı\nIG-1803 | Diğer işlem ücretleri\nIG-1901 | Vadeli mevduat/KH faiz ve kar payı tahakkuku\nIG-1902 | Yatırım Fonu\nIG-1903 | Menkul Kıymet\nIG-1904 | Repo/Ters Repo\nIG-1905 | Türev\nIG-1906 | Altın\nIG-1907 | Diğer Kıymetli Madenler\nIG-2001 | POS Satış işlemleri\nIG-2101 | POS Alış işlemleri\nIG-2201 | Çek\nIG-2202 | Bono\nIG-2203 | Poliçe\nIG-2204 | Diğer Senetler\nIG-2301 | İptal, iade, düzeltme işlemleri\nIG-9999 | Diğer',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemKanali': {
    title: '4.5.1.10. İşlem Kanalı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İşlemin gerçekleştirildiği kanal/kanallar',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Gerçekleştirilmiş bir işlemde (işlem durumu ‘D-01’ ise) bu alan zorunludur.\n• Tek seferde gerçekleştirilmiş işlemler için bildirimi yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan işlem kanallarından birisi belirtilecektir.\n• Belli tarihler arasında gerçekleşmiş çoklu işlemler belirtilirken bildirimi yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan işlem kanallarından bir veya daha fazlası virgül ile ayrılarak belirtilecektir (Örnek: ‘KK-01,KK-02,KK-07’).',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Kod Açıklama\nKK-01 | Şube\nKK-02 | ATM\nKK-03 | İnternet\nKK-04 | POS\nKK-05 | Telefon\nKK-06 | Sistem\nKK-07 | Mobil\nKK-08 | API\nKK-09 | GSM\nKK-10 | Temsilci\nKK-99 | Diğer',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.ipv4': {
    title: '4.5.1.11. IPV4',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği IP bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '8 bitlik 4 grup veya 16 bitlik 8 gruptan oluşur.',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İşlem Kanalı bilgisinde “islemkanali” alanı internet ‘KK-03’ veya mobil ‘KK-07’ veya API ‘KK-08’ seçilmesi halinde işlemin gerçekleştirildiği IP bilgisi belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          '• IPv4 protokolünde gruplar 0 ile 255 arasında değerler alır. IPv4’de bir adres 1.0.0.0 ila 255.255.255.255 aralığındadır.\n• IPv6 adresi her biri iki nokta üst üste ile ayrılmış dört karakter (alfanümerik) içeren sekiz gruptan oluşur.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.port': {
    title: '4.5.1.12. Port',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği port bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'İşlem Kanalı bilgisinde “islemkanali” alanı internet ‘KK-03’ veya mobil ‘KK-07’ veya API ‘KK-08’ seçilmesi halinde işlemin gerçekleştirildiği port bilgisi belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemAciklamasi': {
    title: '4.5.1.13. İşlem Açıklaması',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlem hakkında açıklama bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alanda varsa işlemi gerçekleştiren tarafından beyan edilen işlem açıklaması belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.ulkeKodu': {
    title: '4.5.1.14. Ülke Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği ülke kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, 2 harften oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Yabancı ülke menşeli işlemlerde mutlaka ülke ismine de yer verilmelidir.\n• ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.\n• İşlem Kanalı bilgisinde “islemkanali” alanının Şube ‘KK-01’ veya Temsilci ‘KK-10’ seçilmesi halinde ülke kodu bilgisi belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.ilKodu': {
    title: '4.5.1.15. İl Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği il kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..2] rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İşlem Kanalı bilgisinde “islemkanali” alanının Şube ‘KK-01’ veya Temsilci ‘KK-10’ seçilmesi halinde il bilgisi belirtilecektir.\n• İl kodları belirtilirken Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanan MERNİS il plaka kodları kullanılacaktır.\n• İşlem yurtdışında gerçekleştirilmişse coğrafi konuma dair bilgi (yabancı ülkedeki eyalet, il, ilçe vs.) “islemgerceklestirildigiYer” alanında serbest metin olarak belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.ilceKodu': {
    title: '4.5.1.16. İlçe Kodu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği ilçe kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, 4 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• İlçe kodları belirtilirken Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanan MERNİS ilçe kodları kullanılacaktır.\n• Belirtilen ilçe kodu il kodu alanında belirtilen ile bağlı bir ilçe olmalıdır.\n• İşlem Kanalı bilgisinde “islemkanali” alanının Şube ‘KK-01’ veya Temsilci ‘KK-10’ seçilmesi halinde il koduna bağlı olan ilçe kodu belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemGerceklestirildigiYer': {
    title: '4.5.1.17. İşlemin Gerçekleştirildiği Yer',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin gerçekleştirildiği yer bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bu alan işlemin yurtdışında gerçekleştirilmişse coğrafi konuma dair bilginin (yabancı ülkedeki eyalet, il, ilçe vs.) belirtilmesi için zorunlu.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.isleminTetiklendigiYer': {
    title: '4.5.1.18. İşlemin Tetiklendiği Yer',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlem bildirimine konu olan işlemin/işlemlerin hangi birim tarafından tespit edildiği bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan,[1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Şüpheli işlem bildirimine konu olan işlemlerin aşağıdaki birimlerin hangisi tarafından tespit edildiği belirtilecektir.\n• “Uyum birimi” ise ‘BR-01’\n• “Genel Müdürlük” ise ‘BR-02’\n• “Denetim birimi” ise ‘BR-03’\n• “Şube/Temsilci” ise ‘BR-04’',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Kod Açıklama\nBR-01 | Uyum Birimi\nBR-02 | Genel Müdürlük\nBR-03 | Denetim Birimi\nBR-04 | Şube/Temsilci',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemeAracilikEtmeDurumu': {
    title: '4.5.1.19. İşleme Aracılık Etme Durumu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İşleme Aracılık Eden Finansal Kuruluşun durum bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan,[1..6] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Gerçekleştirilen işlemlerin hangi finansal kuruluş (banka, diğer ödeme kuruluşu) aracılığıyla yapılıp yapılmadığı belirtilecektir\n• “Banka aracılık etmiştir” ise ‘AED-01’\n• “Banka aracılık etmemiştir” ise ‘AED-02’\n• “Diğer Ödeme Kuruluşu aracılık etmiştir” ise ‘AED-03’',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Banka kullanıldığı durumda “Banka aracılık etmiştir.” seçeneği, kullanılmadığı durumlarda “Banka aracılık etmemiştir.” veya “Diğer Ödeme Kuruluşu aracılık etmiştir.” seçeneklerinden biri belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.islemeAracilikEdenKurum': {
    title: '4.5.1.20. İşleme Aracılık Eden Kurum',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'İşleme Aracılık Eden Finansal Kuruluş bilgisi.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Ödeme ve Elektronik Para Kuruluşunun, müşterinin işleminin gerçekleştirilmesinde kullandığı hesabının bulunduğu finansal kuruluşun (bankada EFT kodu, ödeme kuruluşunda kuruluş kodu) bilgisi girilecektir.\n• “islemearaciliketmedurumu” alanında “Banka aracılık etmiştir.” ‘AED-01’ seçilmişse bankada EFT kodu, “Diğer Ödeme Kuruluşu aracılık etmiştir.” ‘AED-03’ seçilmişse ödeme kuruluşuna kuruluş kodu bilgisi bir veya daha fazlası virgül ile ayrılarak belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  hesaplar: {
    title: '4.6. Hesaplar',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description: 'Bu başlık altında şüpheli işlem bildirimindeki eyleme konu olan banka hesabına/hesaplarına dair bilgiler verilecektir.',
        icon: 'info',
      },
    ],
  },
  hesap: {
    title: '4.6.1. Hesap',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description: 'Şüpheli işlem bildirimi içerisinde yer alan her bir hesap bilgisi için bu başlık tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'hesap.sahisFirmasiHesabi': {
    title: '4.6.1.1. Şahıs / Firma Hesabı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesabın şahıs veya firma hesabı olduğunu belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..1] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: "Şahıs hesabı için 'E', Firma hesabı için 'H' değeri girilmelidir.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesap.hesapTuru': {
    title: '4.6.1.2. Hesap Türü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap türü',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bildirim yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan hesap türlerinden birisi belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Kod Açıklama\nHT-01 | Vadesiz Mevduat / Cari Hesap\nHT-02 | Vadeli Mevduat / Katılım Hesabı\nHT-03 | Yatırım Hesabı\nHT-04 | Kredi Hesabı\nHT-05 | Kredi Kartı Hesabı\nHT-06 | Çek/Senet Hesabı\nHT-07 | Kıymetli Maden Hesabı\nHT-08 | POS Hizmetleri için Açılan Hesaplar\nHT-09 | Ticari Hesap\nHT-10 | Ticari Hesap\nHT-11 | Dijital Cüzdan\nHT-12 | Ödeme Hesabı\nHT-13 | Elektronik Para Hesabı\nHT-14 | Ön Ödemeli Araç Hesabı\nHT-15 | Diğer Ödeme Hizmeti Sağlayıcı Hesabı\nHT-99 | Mobil Ödeme GSM Hattı',
        icon: 'link',
      },
    ],
  },
  'hesap.hesapNo': {
    title: '4.6.1.3. Hesap No',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..30] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Hesap numarası içerisinde sadece harf, rakam ve tire (-) yer alabilir.\n• Hesap numarasının başında “0”lar bulunuyorsa “0”lar da içerecek şekilde belirtilmelidir. (Örnek: “00586745”).',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Hesap numarası belirtilirken başına şube kodu kesinlikle eklenmemelidir. Şube kodu bilgisi “hesapsubekodu” alanında belirtilmelidir.',
        icon: 'link',
      },
    ],
  },
  'hesap.iban': {
    title: '4.6.1.4. IBAN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesabın IBAN numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[15..34] boyunda harf ve rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'ISO 13616:1997 standardına uygun olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesap.acilisTarihi': {
    title: '4.6.1.5. Açılış Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesabın açılış tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• 01/01/1900 tarihinden önceki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesap.kapanisTarihi': {
    title: '4.6.1.6. Kapanış Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kapalı hesaplar için hesabın kapanış tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• Açılış tarihinden önceki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Hesap kapanmış ise zorunlu olarak belirtilecektir.',
        icon: 'link',
      },
    ],
  },
  'hesap.sonIslemTarihi': {
    title: '4.6.1.7. Son İşlem Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap üzerinde gerçekleştirilmiş son işlemin tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• Açılış tarihinden önceki bir tarih olmamalıdır.\n• Kapanış tarihinden sonraki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesap.bakiyeTP': {
    title: '4.6.1.8. Bakiye TP',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesabın son işlem tarihindeki Türk Lirası cinsinden bakiyesi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '################.######## formatında numerik bilgi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Yabancı para birimine sahip hesaplar için bu alanda son işlem tarihindeki bakiye bilgisinin ilgili tarihteki kurlara göre Türk Lirası karşılık değeri verilecektir.',
        icon: 'link',
      },
    ],
  },
  'hesap.bakiye': {
    title: '4.6.1.9. Bakiye',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Son işlem tarihindeki hesabın sahip olduğu para birimi cinsinden bakiyesi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '################.######## formatında numerik bilgi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alanda hesapların son işlem tarihindeki bakiye bilgisi belirtilen para birimi cinsinden verilecektir.',
        icon: 'link',
      },
    ],
  },
  'hesap.paraBirimi': {
    title: '4.6.1.10. Para Birimi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesabın para birimi kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '3 harften oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Para birimi ISO 4217 standardında yer alan para birimi kodlarından bir değeri içermelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Hisse senedi, lot vs. gibi işlemler için para birimi alanı ‘XXX’ olarak belirtilecektir.\n\nKod | Kod Açıklama\nADP | Andora Peseta\nAED | Birleşik Arap Emirlikleri Drahmi\nAFA | Afgani (AFN ile Değiştirildi) Eski\nAFN | Afganistan Afganı\nALF | Altın Gram(0.999)\nALK | Lek Eski Arnavutluk\nALL | Arnavutluk Lek\nAMD | Ermeni Dram\nANG | Hollanda Antiller Guikder\nAOA | Angola Kwanza\nAON | Angola Yenikwanza (AOA ile Değiştirildi)\nARP | Arjantin Peso (ARS ile Değiştirildi)\nARS | Arjantin Pezosu\nATS | Avusturya Şilini\nAUD | Avustralya Doları\nAWG | Aruba Florini\nAZM | Azerbaycan Manat (AZN ile Değiştirildi)\nAZN | Azerbaycan Manat\nBAM | Bosna-Hersek Markı\nBBD | Barbados Doları\nBDT | Bangladeş Taka\nBEC | Belçika Frankı (Convertible)\nBEF | Belçika Frankı\nBEL | Belçika Frankı (Financial)\nBGJ | Bulgar Lev A/52 (BGN ile Değiştirildi)\nBGK | Bulgar Lev A/62 (BGN ile Değiştirildi)\nBGL | Bulgar Lev A/99 (BGN ile Değiştirildi)\nBGN | Bulgar Lev\nBHD | Bahreyn Dinarı\nBIF | Burundi Frankı\nBMD | Bermuda Doları\nBND | Brunei Doları\nBOB | Boliviano\nBOP | Bolivya Pesosu (BOB ile Değiştirildi)\nBOV | Bolivya Mvdol\nBRB | Brezilya Cruzeiro (BRL ile Değiştirildi)\nBRC | Brezilya Cruzado (BRL ile Değiştirildi)\nBRL | Brezilya Reali\nBSD | Bahama Doları\nBWP | Botsvana Pulası\nBYN | Belarus Rublesi\nBZD | Belize Doları\nCAD | Kanada Doları\nCDF | Kongo Frankı\nCDZ | Zaire (CDF ile Değiştirildi)\nCHF | İsviçre Frangı\nCLP | Şili Pezosu\nCNH | Çin Offshore Yuanı\nCNX | Çin Halk Bankası Doları (CNY ile Değiştirildi)\nCNY | Çin Yuanı\nCOP | Kolombiya Pezosu\nCRC | Kosta Rika Kolonu\nCSD | Eski Sırbistan Dinarı\nCSJ | Çekoslavak Koruna A/53\nCSK | Çekoslavak Koruna (CZK ve SKK ile Değiştirildi)\nCUP | Küba Pezosu\nCVE | Cape Verde Esküdosu\nCYP | Kıbrıs Poundu\nCYR | Çeyrek Altın\nCZK | Çek Korunası\nDDM | Doğu Almanya Markı (DEM ile Değiştirildi)\nDEM | Alman Markı\nDJF | Cibuti Frankı\nDKK | Danimarka Kronu\nDOP | Dominik Pezosu\nDZD | Cezayir Dinarı\nECS | Ekvator Sucre (USD ile Değiştirildi)\nEEK | Estonya Kronu\nEGP | Mısır Poundu\nERN | Eritre Nafka\nESA | İspanyol Pezeta (Hesap A)\nESB | İspanyol Pezeta (Hesap B)\nESP | İspanyol Pezeta\nETB | Etiyopya Birri\nEUR | Euro\nFIM | Finlandiya Markası\nFJD | Fiji Doları\nFKP | Falkland Adaları Poundu\nFRF | Fransız Frankı\nGBP | İngiliz Sterlini\nGEL | Gürcü Larisi\nGHC | Gana Cedi\nGIP | Cebelitarık Poundu\nGMD | Gambiya Dalasisi\nGNF | Gine Frankı\nGRD | Yunan Drahmisi\nGTQ | Guatemala Quetzalı\nGWP | Gine-Bissau Pezosu\nGYD | Guyana Doları\nHKD | Hong Kong Doları\nHNL | Honduras Lempirası\nHRK | Hırvat Kunası\nHUF | Macar Forinti\nIDR | Endonezya Rupiahı\nIEP | İrlanda Poundu\nILP | İsrail Poundu (ILR ile Değiştirildi)\nILR | İsrail Eski Şekeli (ILS ile Değiştirildi)\nILS | İsrail Şekeli\nINR | Hindistan Rupisi\nIQD | Irak Dinarı\nIRR | İran Riyali\nISJ | İzlanda Eski Kronu (ISK ile Değiştirildi)\nISK | İzlanda Kronu\nITL | İtalyan Lireti\nJMD | Jamaika Doları\nJOD | Ürdün Dinarı\nJPY | Japon Yeni\nKES | Kenya Şilini\nKGS | Kırgız Somu\nKHR | Kamboçya Rieli\nKMF | Komor Frankı\nKPW | Kuzey Kore Wonu\nKRW | Güney Kore Wonu\nKWD | Kuveyt Dinarı\nKYD | Cayman Adaları Doları\nKZT | Kazakistan Tengesi\nLAK | Lao Halk Cumhuriyeti Kipi\nLBP | Lübnan Poundu\nLKR | Sri Lanka Rupisi\nLRD | Liberya Doları\nLTL | Litvanya Litası\nLUF | Lüksemburg Frankı\nLYD | Libya Dinarı\nMAD | Fas Dirhemi\nMDL | Moldova Leusu\nMGA | Madagaskar Ariarisi\nMKD | Makedonya Dinarı\nMKN | Makedonya Dinarı A/93 (MKD ile Değiştirildi)\nMNT | Moğolistan Tugriki\nMRO | Moritanya Ouguiyası\nMTL | Malta Lirası\nMUR | Mauritius Rupisi\nMVQ | Maldiv Rupisi (MVR ile Değiştirildi)\nMVR | Maldiv Rufiyası\nMWK | Malavi Kvaçası\nMXN | Meksika Pezosu\nMXP | Meksika Pesosu (MXN ile Değiştirildi)\nMYR | Malezya Ringgiti\nMZN | Mozambik Metikali\nNGN | Nijerya Nairası\nNIO | Nikaragua Córdobası\nNLG | Hollanda Florini\nNOK | Norveç Kronu\nNPR | Nepal Rupisi\nNZD | Yeni Zelanda Doları\nOMR | Umman Riyali\nPEH | Peru Solu (PEN ile Değiştirildi)\nPEN | Peru Solu\nPGK | Papua Yeni Gine Kina\nPHP | Filipin Pezosu\nPKR | Pakistan Rupisi\nPLN | Polonya Zlotisi\nPLZ | Polonya Zlotisi A/94 (PLN ile Değiştirildi)\nPTE | Portekiz Esküdosu\nPYG | Paraguay Guaranisi\nQAR | Katar Riyali\nROK | Romanya Leusu A/52 (ROL ile Değiştirildi)\nROL | Romanya Leusu A/05 (RON ile Değiştirildi)\nRON | Rumen Yeni Leusu\nRSD | Sırbistan Dinarı\nRUB | Rusya Rublesi\nRUR | Rusya Rublesi (RUB ile Değiştirildi)\nRWF | Ruanda Frankı\nSAR | Suudi Arabistan Riyali\nSBD | Solomon Adaları Doları\nSCR | Seyşeller Rupisi\nSDD | Sudan Dinarı\nSEK | İsveç Kronu\nSGD | Singapur Doları\nSHP | Saint Helena Poundu\nSIT | Slovenya Toları\nSKK | Slovak Korunası\nSLE | Sierra Leone Leonesi\nSOS | Somali Şilini\nSRD | Surinam Doları\nSRG | Surinam Guildeni (SRD ile Değiştirildi)\nSUR | Sovyetler Birliği Rublesi (RUB ile Değiştirildi)\nSVC | El Salvador Kolonu\nSYP | Suriye Poundu\nSZL | Esvatini Lilangeni\nTHB | Tayland Bahtı\nTJS | Tacikistan Somonisi\nTMM | Türkmenistan Manatı (Eski)\nTMT | Türkmenistan Manatı (Yeni)\nTND | Tunus Dinarı\nTOP | Tonga Pa’angası\nTPE | Timor Esküdosu\nTRL | Türk Lirası (Eski)\nTRY | Türk Lirası\nTTD | Trinidad Tobago Doları\nTWD | Tayvan Doları\nTZS | Tanzanya Şilini\nUAH | Ukrayna Grivnası\nUGW | Uganda Eski Şilini (UGX ile Değiştirildi)\nUGX | Uganda Şilini\nUSD | ABD Doları\nUYN | Uruguay Eski Pesosu (UYU ile Değiştirildi)\nUYU | Uruguay Pezosu\nUZS | Özbekistan Somu\nVED | Venezuela Bolivarı\nVNC | Vietnam Eski Dongu (VND ile Değiştirildi)\nVND | Vietnam Dongu\nVUV | Vanuatu Vatusu\nWST | Samoa Tala\nXAF | CFA Frankı\nXAG | Gümüş\nXAU | Altın\nXBA | Bond Markets Units European\nXBB | European Monetary Unit\nXBC | E.U.A.-9\nXBD | E.U.A.-17\nXCD | Doğu Karayip Doları\nXDR | Özel Çekme Hakları\nXEU | Avrupa Para Değişim Birimi (ECU)\nXFO | Gold-Franc\nXFU | UIC-Franc\nXOF | CFA Frankı (BCEAO)\nXPD | Paladyum\nXPF | Fransız Polinezyası Frankı\nXPT | Platin\nYDD | Güney Yemen Dinarı (YER ile Değiştirildi)\nYER | Yemen Riyali\nYUD | Yugoslavya Dinarı (CSD ile Değiştirildi)\nYUM | Yugoslavya Dinarı\nZAR | Güney Afrika Randı\nZMW | Zambiya Kvaçası\nZWL | Zimbabve Doları\nAAA | AAAAAA',
        icon: 'link',
      },
    ],
  },
  'hesap.kisitlamaturu': {
    title: '4.6.1.11. Kısıtlama Türü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap üzerinde yasal kısıtlama varsa türü belirtilecektir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..500] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Hesap üzerindeki yasal kısıtlamanın nedeni;\n• 5271 SK md 128/Elkoyma ise "YK-01" olarak belirtilecektir.\n• 5549 SK md 19-A/İşlem ertelemesi ise "YK-02" olarak belirtilecektir.\n• 6415 SK ise "YK-03" olarak belirtilecektir.\n• 7262 SK ise "YK-04" olarak belirtilecektir.\n• 2004 SK ise "YK-05" olarak belirtilecektir.\n• 6183 SK ise "YK-06" olarak belirtilecektir.\n• Diğer ise "YK-07" olarak belirtilecektir.\n\n"kisitlamaturu" alanının Diğer "YK-07" seçilmesi halinde yasal kısıtlamaya ilişkin açıklama "kisitlamadigeraciklama" alanında belirtilecek ve "YK-07" dışında başka bir yasal kısıtlama nedeni seçilemeyecektir.\n\nHesap üzerindeki yasal kısıtlama nedeni birden fazla ise Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan yasal kısıtlama nedenlerinden bir veya daha fazlası virgül ile ayrılarak belirtilecektir. (Örnek: "YK-01,YK-02,YK-05")',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Kod Açıklama\nYK-01 | 5271 SK md 128/Elkoyma\nYK-02 | 5549 SK md 19-A/İşlem ertelemesi\nYK-03 | 6415 SK\nYK-04 | 7262 SK\nYK-05 | 2004 SK\nYK-06 | 6183 SK\nYK-07 | Diğer',
        icon: 'link',
      },
    ],
  },
  'hesap.kisitlamadigeraciklama': {
    title: '4.6.1.12. Kısıtlama Diğer Açıklama',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bu alanda yasal kısıtlamanın türünün diğer seçilmesi halinde hesap üzerinde var olan kısıtlamaların mahiyeti açıklanacaktır.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..250] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '"kisitlamaturu" alanının Diğer "YK-07" belirtilmesi halinde kısıtlama nedeni açıklaması belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  hesapSahipleri: {
    title: '4.6.1.13. Hesap Sahipleri',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında her bir hesabın sahibine/sahiplerine dair bilgiler verilecektir. Ortak hesaplar için hesap sahibi başlığı her bir hesap sahibi için tekrarlanacaktır. Hesap sahiplerinde tanımlanan kişilerin "gercekkisiler" ve/veya "digerkisiler" başlıklarında tanımlanan kişilerle bilgilerinin eşleşmesi ve ayrıca bu kişilerin dışında yeni kişilerin bu bölümde tanımlanmaması gerekmektedir.',
        icon: 'info',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi': {
    title: '4.6.1.13.1. Hesap Sahibi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Her bir hesap sahibi bu başlık kullanılarak belirtilecektir. "gercekkisiler" ve/veya "digerkisiler" başlıklarında belirtilen hesap sahibine ait mağdur, ad, soyad, TCKN, YKN, VKN ve pasaport bilgilerinin aynı şekilde belirtilmesi zorunludur.',
        icon: 'info',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.magdur': {
    title: '4.6.1.13.1.1. Mağdur',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemi gerçekleştiren kişinin bilinmemesi ve yalnızca müşteri olan mağdura ilişkin bilgiler varsa belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“E” veya “H” harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Gerçek ve tüzel/diger kişiye ait belirtilen bilgilerde; kişi mağdur ise “E”, kişi mağdur değilse “H” değeri girilmelidir.\n• “gercekkisiler” ve/veya “digerkisiler” başlıklarında belirtildiği şekilde aynı bilgi tanımlanmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.adSoyadUnvan': {
    title: '4.6.1.13.1.2. Ad Soyad Unvan',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap sahibi gerçek kişi ise ad ve soyadı, tüzel/diger kişi ise unvan bilgisi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..250] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Hesap sahibi tüzel kişi veya tüzel kişiliği olmayan bir teşekkül ise unvanı belirtilmelidir.\n• Hesap sahibi gerçek kişi ise adı ve soyadı belirtilmelidir.\n• “gercekkisiler” ve/veya “digerkisiler” başlıklarında belirtildiği şekilde aynı bilgi tanımlanmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.tckn': {
    title: '4.6.1.13.1.3. TCKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap sahibinin TC kimlik numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '11 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Bu alanda belirtilen bilgi Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanmış TCKN üretme algoritmasına uygun olarak üretilmiş bir TCKN olmalıdır.\n• “gercekkisiler” başlığında “tckn” bilgisi varsa bu alanda aynı bilgi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alanda; TCKN’si bilinen Türk vatandaşları için TC kimlik numarası belirtilmelidir.',
        icon: 'link',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.vkn': {
    title: '4.6.1.13.1.4. VKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Hesap sahibinin vergi numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '10 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Bu alanda belirtilen vergi kimlik numarası Gelir İdaresi Başkanlığı tarafından yayınlanan VKN üretme algoritmasına uygun olmalıdır.\n• “gercekkisiler” ve/veya “digerkisiler” başlıklarında “vkn” bilgisi varsa bu alanda aynı bilgi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.ykn': {
    title: '4.6.1.13.1.5. YKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Yabancı uyruklu hesap sahibi kişiler için Yabancı Kimlik Numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '11 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Bu alanda belirtilen bilgi Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanmış YKN üretme algoritmasına uygun olarak üretilmiş bir YKN olmalıdır.\n• “gercekkisiler” başlığında “ykn” bilgisi varsa bu alanda aynı bilgi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alanda; yabancı uyruklu kişiler için YKN belirtilmelidir.',
        icon: 'link',
      },
    ],
  },
  'hesapSahipleri.hesapSahibi.pasaport': {
    title: '4.6.1.13.1.6. Pasaport',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Yabancı uyruklu hesap sahibi kişiler için pasaport numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..20] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '“gercekkisiler” başlığında “pasaport” bilgisi varsa bu alanda aynı bilgi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  supheKategorileri: {
    title: '4.7. Şüphe Kategorileri',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında şüpheli işlem bildirimi kapsamında beyan edilecek olan şüphe kategorileri belirtilecektir. Bildirilecek olan her bir şüphe kategorisine bu başlık altında ayrı ayrı yer verilecektir.',
        icon: 'info',
      },
    ],
  },
  'supheKategorileri.supheKategorisi': {
    title: '4.7.1. Şüphe Kategorisi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüphe kategorisinin kodu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bildirimi yapan yükümlünün faaliyet gösterdiği sektör için Başkanlık tarafından yayınlanmış olan Şüpheli İşlem Bildirim Rehberi içerisinde yer alan şüphe kategorilerinden en az biri ve en fazla üçü seçilerek belirtilecektir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          '• Terörizmin Finansmanı kategorisinde gönderilen bildirimlerde (“bildirimkategorisi” alanı ‘BK-02’ ise) “SK-23 Terörizmin finansmanı” veya “SK-35 Mal varlığının dondurulması kararının ihlali” şüphe kategorilerinden en az birinin seçimi zorunlu olacak, maksimum sınırı geçmeyecek şekilde diğer şüphe kategorilerden de seçim yapılabilecektir.\n• Kitle imha silahlarının yayılmasının finansmanı kategorisinde gönderilen bildirimlerde (“bildirimkategorisi” alanı ‘BK-03’ ise) “SK-36 Kitle imha silahlarının yayılmasının finansmanı” şüphe kategorisi seçimi zorunlu olacak, maksimum sınırı geçmeyecek şekilde diğer şüphe kategorilerden de seçim yapılabilecektir.\n\nKod | Kod Açıklama\nSK-01 | Tefecilik\nSK-02 | POS Tefeciliği\nSK-03 | Fuhuşa teşvik veya aracılık etmek\nSK-04 | Göçmen kaçakçılığı / insan ticareti\nSK-05 | Uyuşturucu madde ticareti\nSK-06 | Silah ve mühimmat kaçakçılığı\nSK-07 | Tarihi eser kaçakçılığı (kültür varlığı ticareti)\nSK-08 | Gümrük kaçakçılığı / hayali ihracat\nSK-09 | Kıymetli maden ve taşların kaçakçılığı\nSK-10 | Bilişim suçları\nSK-11 | Vergi kaçakçılığı ve vergi kaçırma\nSK-12 | Sermaye piyasalarına ilişkin suçlar\nSK-13 | Yolsuzluk ve kamu görevlileriyle ilgili suçlar (rüşvet, irtikap, zimmet, kamu görevlisinin haksız mal edinmesi ve diğer yolsuzluk ve görev suçları)\nSK-14 | Resmî / özel evrakta sahtecilik\nSK-15 | Para ve kıymetli evrak dolandırıcılığı/sahteciliği\nSK-16 | Sigorta dolandırıcılığı/poliçe sahteciliği\nSK-17 | Dolandırıcılık\nSK-18 | Organ ve doku ticareti\nSK-19 | Tehdit/şantaj/cebir ve adam kaçırma\nSK-20 | Mal varlığına karşı suçlar (hırsızlık, yağma vs.)\nSK-21 | Hileli iflas\nSK-22 | Yasa dışı bahis ve kumar oynatma/oynanmasına aracılık etme\nSK-23 | Terörizmin finansmanı\nSK-24 | İhaleye fesat karıştırma\nSK-25 | Sosyal güvenlik mevzuatına aykırılıklar\nSK-26 | Bankacılık mevzuatına ilişkin suçlar\nSK-27 | Akaryakıt kaçakçılığı\nSK-28 | Yasa dışı fatura ödeme merkezi faaliyetleri\nSK-29 | Lisanssız ödeme ve elektronik para hizmetlerinde bulunma\nSK-30 | Başkası hesabına işlem yapıldığının beyan edilmemesi\nSK-31 | Sigara, alkol ve tütün mamulleri kaçakçılığı\nSK-32 | Piramit satış sistemleri (saadet zincirleri)\nSK-33 | Sivil toplum kuruluşlarının suiistimali\nSK-34 | Yasadışı yardım ve bağış toplama\nSK-35 | Mal varlığının dondurulması kararının ihlali\nSK-36 | Kitle imha silahlarının yayılmasının finansmanı\nSK-37 | Yükümlülüklere aykırı hareket edilmesi\nSK-38 | Müstehcenlik',
        icon: 'link',
      },
    ],
  },
  bildirimAciklama: {
    title: '4.8. Bildirim Açıklama',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlem bildirimine dair açıklama',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[100..50000] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'En az 100 karakter girilmesi zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  temelBilgi: {
    title: '4.2. Temel Bilgiler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında şüpheli işlem bildirimine dair temel bilgilere yer verilir. Temel bilgiler alanı her bir XML içerisinde bir defa yer alabilmektedir. Temel bilgiler alanının bildirimi zorunludur.',
        icon: 'info',
      },
    ],
  },
  'temelBilgi.bildirimKategorisi': {
    title: '4.2.1. Bildirim Kategorisi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Şüpheli işlem bildiriminin suç gelirlerinin aklanması, terörizmin finansmanı ya da kitle imha silahlarının yayılmasının finansmanı suçuyla ilgili olup olmadığı belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          "Bildirim kategorisi alanında;\n• Suç Gelirlerinin Aklanması 'BK-01'\n• Terörizmin Finansmanı 'BK-02'\n• Kitle İmha Silahlarının Yayılmasının Finansmanı 'BK-03' değeri girilmelidir.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Açıklama\nBK-01 | Suç Gelirlerinin Aklanması\nBK-02 | Terörizmin Finansmanı\nBK-03 | Kitle İmha Silahlarının Yayılmasının Finansmanı',
        icon: 'link',
      },
    ],
  },
  'temelBilgi.yerelReferansNo': {
    title: '4.2.2. Yerel Referans No',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirme yükümlü tarafından verilen referans numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..50] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'others',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'temelBilgi.oncekiBildirimReferansNo': {
    title: '4.2.3. Önceki Bildirim Referans No',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Bildirim daha önce gönderilmiş bir şüpheli işlem bildiriminin eki ise önceki bildirimde yükümlü tarafından verilmiş olan referans numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..50] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Önceki bildirim referans numarası sadece ek ŞİB bildirimlerinde doldurulmalıdır.\n• Önceki bildirim referans numarası alanı daha önce MASAK’a gönderilmiş olan bir ŞİB’in yükümlü tarafından verilen referans numarasını (“yerel referans no”) taşımalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Önceki bildirim referans numarası alanının boş olması ŞİB’in yeni bir bildirim (ek olmayan bir bildirim) olduğu anlamını taşır.',
        icon: 'link',
      },
    ],
  },
  'temelBilgi.aciliyet': {
    title: '4.2.4. Aciliyet',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimin aciliyet durumu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Aciliyet durum alanı;\n• Normal bildirimler için ‘A-01’\n• İvedi bildirimler için ‘A-02’\n• Çok ivedi bildirimler için ‘A-03’\n• İşlemin ertelenmesi talepli bildirimler için ‘A-04’ değerini taşımalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Açıklama\nA-01 | Normal\nA-02 | İvedi\nA-03 | Çok İvedi\nA-04 | İşlemin Ertelenmesi Talepli',
        icon: 'link',
      },
    ],
  },
  'temelBilgi.terorOrgutu': {
    title: '4.2.5. Terör Örgütü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Terörizmin finansmanı bildirim kategorisinde gönderilen bildirimlerde terör örgütü seçimi yapılır.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Şüpheli işlem bildiriminde;\n• Bölücü terör örgütleri için ‘TO-01’\n• Dini istismar eden bölücü örgütler için ‘TO-02’\n• Aşırı sol terör örgütleri için ‘TO-03’ değeri girilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Terörizmin Finansmanı bildirim kategorisinde (“bildirim kategorisi” alanı ‘BK-02’) gönderilen bildirimlerde doldurulması zorunludur.\n\nKod | Açıklama\nTO-01 | Bölücü Terör Örgütleri\nTO-02 | Dini İstismar Eden Terör Örgütleri\nTO-03 | Aşırı Sol Terör Örgütleri',
        icon: 'link',
      },
    ],
  },
  gercekKisiler: {
    title: '4.3. Gerçek Kişiler',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında şüpheli işlem bildiriminde yer alan eylem ile doğrudan veya dolaylı olarak ilgisi bulunan tüm gerçek kişilerin bilgilerine yer verilecektir.',
        icon: 'info',
      },
    ],
  },
  gercekKisi: {
    title: '4.3.1. Gerçek Kişi',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık şüpheli işlem bildirimindeki eylem ile ilgisi bulunan gerçek kişileri belirtmek amacı ile kullanılır. Şüpheli işlem ile doğrudan veya dolaylı olarak ilgili olan her bir gerçek kişi için bu başlık tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.islemleBaglantisi': {
    title: '4.3.1.1. İşlemle Bağlantısı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Gerçek kişinin şüpheli işlem ile olan bağlantısı belirtilir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Gerçek kişinin şüpheli işlem ile olan bağlantısı;\n• Kendisi Adına İşlem Yapan kişi ise ‘GB-01’\n• Başkası Adına İşlem Yapan kişi ise ‘GB-02’\n• Adına İşlem Yapılan kişi ise ‘GB-03’\n• Gerçek Faydalanıcı kişi ise ‘GB-04’\n• Dolaylı Olarak ilgili kişi ise ‘GB-05’ değerini taşımalıdır.\n\nKişi mağdur değilse (“mağdur” alanı ‘H’ ise) bu alan zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'GB-01 | Kendisi Adına İşlem Yapan\nGB-02 | Başkası Adına İşlem Yapan\nGB-03 | Adına İşlem Yapılan\nGB-04 | Gerçek Faydalanıcı\nGB-05 | Dolaylı Olarak İlgili',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.islemleBaglantisiAciklama': {
    title: '4.3.1.2. İşlemle Bağlantısı Açıklama',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Gerçek kişinin şüpheli işlem ile olan bağlantısının açıklaması',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..100] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: "Bu alan 'islemleBaglantisi' alanı Dolaylı olarak ilgili kişi ‘GB-05’ seçildiğinde belirtilmelidir. Aksi durumda boş bırakılmalıdır.",
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.adi': {
    title: '4.3.1.3. Adı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin adı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Birden fazla ismi olanlar için tüm isimler bu alanda belirtilmelidir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.soyadi': {
    title: '4.3.1.4. Soyadı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin soyadı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[1..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.tckn': {
    title: '4.3.1.5. TCKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin TC kimlik numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '11 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bu alanda belirtilen bilgi Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanmış YKN üretme algoritmasına uygun olarak üretilmiş YKN olmalıdır.\nBasitleştirilmiş Tedbirler ‘KTT-01’ kimlik tespit türü seçildiğinde zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Bu alanda; TCKN’si bilinen Türk vatandaşları için T.C. kimlik numarası beyan edilecektir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.vkn': {
    title: '4.3.1.6. VKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin vergi kimlik numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '10 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: 'Bu alanda belirtilen vergi kimlik numarası Gelir İdaresi Başkanlığı tarafından yayınlanan VKN üretme algoritmasına uygun olmalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.ykn': {
    title: '4.3.1.7. YKN',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin yabancı kimlik numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '11 rakamdan oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bu alanda belirtilen bilgi Nüfus ve Vatandaşlık İşleri Genel Müdürlüğü tarafından yayınlanmış YKN üretme algoritmasına uygun olarak üretilmiş YKN olmalıdır.\nYabancı uyruklulara Basitleştirilmiş Tedbirler ‘KTT-01’ kimlik tespit türü seçildiğinde zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'YKN’si bilinen yabancı uyruklu kişiler için Yabancı Kimlik Numarası beyan edilecektir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.dogumTarihi': {
    title: '4.3.1.8. Doğum Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen gerçek kişinin doğum tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Günün tarihinden sonraki bir tarih olmamalıdır.\n• 01/01/1900 tarihinden önceki bir tarih olmamalıdır.\n• Kişi mağdur değilse (“mağdur” alanı H ise) bu alan zorunludur.\n• Basitleştirilmiş Tedbirler “KTT-01”, Tedbirler Yönetmeliği “KTT-02” veya Uzaktan Kimlik Tespiti “KTT-03” türü seçildiğinde zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.dogumYeri': {
    title: '4.3.1.9. Doğum Yeri',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen gerçek kişinin doğum yeri',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..30] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.anaAdi': {
    title: '4.3.1.10. Ana Adı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin annesinin adı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Anne adı birden fazla ise tüm isimler bu alanda verilmelidir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.babaAdi': {
    title: '4.3.1.11. Baba Adı',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin babasının adı',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..50] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Baba adı birden fazla ise tüm isimler bu alanda verilmelidir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.uyrugu': {
    title: '4.3.1.12. Uyruğu',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin uyruğu',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '2 harften oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• ISO 3166-2 standardında yer alan ve 2 harften oluşan ülke kodlarından birisi belirtilmelidir.\n• Gerçek kişi mağdur değilse (“mağdur” alanı H ise) ve Basitleştirilmiş Tedbirler ‘KTT-01’ veya Tedbirler Yönetmeliği ‘KTT-02’ ya da Uzaktan Kimlik Tespiti ‘KTT-03’ kimlik tespiti türü seçildiğinde girişi zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.cinsiyeti': {
    title: '4.3.1.13. Cinsiyeti',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Bildirimde adı geçen kişinin cinsiyeti',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '‘E’, ‘K’ veya ‘B’ harfi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• Gerçek kişinin cinsiyeti; Erkek ise ‘E’, Kadın ise ‘K’, Bilinmiyor ise ‘B’ harfi ile belirtilmelidir.\n• Kişi mağdur değilse (“mağdur” alanı H ise) bu alan zorunludur.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: 'Kod | Açıklama\nK | Kadın\nE | Erkek\nB | Bilinmiyor',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.kimlikBelgesi': {
    title: '4.3.1.4. Kimlik Belgeleri',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık altında kişinin yükümlü tarafından sahip olunan veya bilinen kimlik belgelerine (yeni tip kimlik kartı, nüfus cüzdanı, sürücü belgesi, pasaport vs.) dair bilgiler verilecektir. Kimlik belgeleri alanında kimlikBelgesi tag’i açılmışsa (Örneğin Nüfus Cüzdanı KT-01 gibi) belge türü ve belge numarasının doldurulması zorunludur aksi halde zorunlu değildir.',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.kimlikBelgesiBilgisi': {
    title: '4.3.1.15. Kimlik Belgesi',
    sections: [
      {
        id: 'summary',
        title: 'Bilgilendirme',
        description:
          'Bu başlık gerçek kişinin kimlik belgelerine dair bilgilerin belirtilmesi için kullanılacaktır. Birden fazla kimlik belgesine dair bilgiler verilecekse her bir kimlik belgesi için bu başlık tekrarlanacaktır.',
        icon: 'info',
      },
    ],
  },
  'gercekKisi.kimlikBelgesiBilgisi.belgeTuru': {
    title: '4.3.1.15.1. Belge Türü',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description:
          'Kişinin yükümlü nezdinde işlem yaptırırken ibraz ettiği kimlik belgesinin (Nüfus cüzdanı, yeni tip kimlik kartı, sürücü belgesi, yeni tip sürücü belgesi, pasaport, vs.) türü',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: 'Kodlu alan, [1..5] boyunda karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          'Bu alanda bilgisi verilecek kimliğe esas belge;\n• Nüfus cüzdanı ise ‘KT-01’\n• T.C. Kimlik Kartı ise ‘KT-02’\n• Yeni Tip Sürücü Belgesi ise ‘KT-03’\n• Pasaport ise ‘KT-04’\n• İkamet izin belgesi ise ‘KT-05’\n• Sürücü belgesi ise ‘KT-06’\n• Diğer kimlik belgeleri için ‘KT-99’ kodlarından birisi belirtilmelidir.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Kod | Açıklama\nKT-01 | Nüfus Cüzdanı\nKT-02 | T.C. Kimlik Kartı\nKT-03 | Yeni Tip Sürücü Belgesi\nKT-04 | Pasaport\nKT-05 | İkamet İzin Belgesi\nKT-06 | Sürücü Belgesi\nKT-99 | Diğer Belge',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.kimlikBelgesiBilgisi.belgeNumarasi': {
    title: '4.3.1.15.2. Belge Numarası',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kimlik belirten belgenin numarası',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Zorunlu',
          tone: 'danger',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '[0..20] karakterden oluşan karakter dizisi',
        icon: 'database',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description: '-',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'Belirtilecek olan belge numarası seri ve numaradan oluşuyorsa (T.C. nüfus cüzdanı seri ve numarası gibi) her iki değer bu alanda araya bir tire (-) koyup birleştirilerek verilmelidir.',
        icon: 'link',
      },
    ],
  },
  'gercekKisi.kimlikBelgesiBilgisi.gecerlilikTarihi': {
    title: '4.3.1.15.3. Geçerlilik Tarihi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Kimlik belirten belgenin geçerlilik tarihi',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Opsiyonel alan',
        icon: 'checkbox',
        badge: {
          text: 'Opsiyonel',
          tone: 'success',
        },
      },
      {
        id: 'dataType',
        title: 'Veri Tipi',
        description: '“GG/AA/YYYY” formatında tarih bilgisi',
        icon: 'calendar',
      },
      {
        id: 'constraints',
        title: 'Kısıtlamalar',
        description:
          '• “belgeTuru” parametresinde; T.C. Kimlik Kartı ‘KT-02’, Yeni Tip Sürücü Belgesi ‘KT-03’, pasaport ‘KT-04’, ikamet izin belgesi ‘KT-05’ kodları seçilmişse geçerlilik tarihi belirtilir.\n• Günün tarihinden önceki bir tarih olmamalıdır.',
        icon: 'warning',
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description: '-',
        icon: 'link',
      },
    ],
  },
  'supheliIslem.iletisimBilgileri.tip': {
    title: '4.5.1.15.1. İletişim Bilgisi Tipi',
    sections: [
      {
        id: 'definition',
        title: 'Tanım',
        description: 'Şüpheli işlemin iletişim bilgisini belirtir.',
        icon: 'info',
      },
      {
        id: 'mandatory',
        title: 'Zorunluluk Tipi',
        description: 'Koşullu Zorunlu alan',
        icon: 'checkbox',
        badge: {
          text: 'Koşullu Zorunlu',
          tone: 'warning',
        },
      },
      {
        id: 'otherInfo',
        title: 'Diğer Bilgiler',
        description:
          'İletişim bilgisi tipi belirtilen bilginin türüne göre;\n• İş Telefonu numarası ise iletişim tipi="is"\n• Ev Telefonu numarası ise iletişim tipi="ev"\n• Cep Telefonu numarası ise iletişim tipi="cep"\n• Diğer Telefon numarası ise iletişim tipi="diger"\n• Faks numarası ise iletişim tipi="faks"\n• E-posta adresi ise iletişim tipi="eposta"',
        icon: 'link',
      },
    ],
  },
};
